import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";

interface Props {
  name: string | undefined;
  type: "report" | "template";
  isLoading?: boolean;
  onSave: () => void;
  onContinue: () => void;
  onCancel: () => void;
}

export default function UnsavedChangesDialog({ name, type, onSave, onContinue, onCancel, isLoading }: Props) {
  const contentTitle = `Unsaved ${type === "report" ? "Report" : "Template"} ${name && `"${name}"`}`;

  return (
    <SmallDialog open={true} onClose={onCancel}>
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogCloseButton onClick={onCancel} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <WarningDialogIcon sx={{ width: 80, height: 80 }} />
          <Stack spacing={1} sx={{ alignItems: "center", textAlign: "center" }}>
            <Typography variant="h6" sx={{ wordBreak: "break-all" }}>
              {contentTitle}
            </Typography>
            <Typography color="textSecondary">
              Your changes have not been saved. Do you want to save your changes, discard them, or stay on this page?
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons
        startAction={
          <Button variant="text" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
        }
      >
        <Button variant="outlined" onClick={onSave} loading={isLoading}>
          Save Changes
        </Button>
        <Button variant="contained" onClick={onContinue}>
          Discard & Continue
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
}
